import { getClientSource } from "../common/Functions";

const NOTIFICATION_TAG_IDLE = "tcs-time-tracker-idle";
const NOTIFICATION_TAG_AUTO_PAUSE = "tcs-time-tracker-auto-pause";

let idleNotification = null;
let titleFlashInterval = null;
let originalDocumentTitle = null;
let audioContext = null;

const getNotificationIcon = () => {
  const source = typeof getClientSource === "function" ? getClientSource() : "tcs";
  return source === "sattva" ? "/icon/sattva-logo.png" : "/icon/tcs-logo.png";
};

export const isDesktopNotificationSupported = () =>
  typeof window !== "undefined" && "Notification" in window;

export const getDesktopNotificationPermission = () => {
  if (!isDesktopNotificationSupported()) return "denied";
  return Notification.permission;
};

export const requestDesktopNotificationPermission = async () => {
  if (!isDesktopNotificationSupported()) return "denied";
  if (Notification.permission === "granted") return "granted";
  if (Notification.permission === "denied") return "denied";
  try {
    return await Notification.requestPermission();
  } catch (_error) {
    return "denied";
  }
};

const playAlertTone = () => {
  try {
    const Ctx = window.AudioContext || window.webkitAudioContext;
    if (!Ctx) return;
    if (!audioContext) audioContext = new Ctx();
    if (audioContext.state === "suspended") {
      audioContext.resume().catch(() => {});
    }
    const oscillator = audioContext.createOscillator();
    const gain = audioContext.createGain();
    oscillator.type = "sine";
    oscillator.frequency.value = 880;
    gain.gain.value = 0.08;
    oscillator.connect(gain);
    gain.connect(audioContext.destination);
    oscillator.start();
    oscillator.stop(audioContext.currentTime + 0.35);
  } catch (_error) {
    // Optional alert sound — ignore if blocked.
  }
};

export const startTitleFlash = (message = "⚠ Inactivity detected — Time Tracker") => {
  if (typeof document === "undefined") return;
  stopTitleFlash();
  originalDocumentTitle = document.title;
  titleFlashInterval = window.setInterval(() => {
    document.title =
      document.title === originalDocumentTitle ? message : originalDocumentTitle;
  }, 1000);
};

export const stopTitleFlash = () => {
  if (titleFlashInterval) {
    clearInterval(titleFlashInterval);
    titleFlashInterval = null;
  }
  if (originalDocumentTitle != null && typeof document !== "undefined") {
    document.title = originalDocumentTitle;
    originalDocumentTitle = null;
  }
};

export const closeIdleDesktopAlert = () => {
  if (idleNotification) {
    idleNotification.close();
    idleNotification = null;
  }
};

/** Desktop notifications disabled — idle still handled via in-app modal / auto-pause. */
export const showIdleDesktopAlert = ({ onOpenDashboard } = {}) => {
  // playAlertTone();
  // startTitleFlash();
  //
  // if (!isDesktopNotificationSupported() || Notification.permission !== "granted") {
  //   return false;
  // }
  //
  // closeIdleDesktopAlert();
  //
  // idleNotification = new Notification("Time Tracker — Inactivity Detected", {
  //   body: "No activity detected. Are you still here? Click to open the dashboard. Your session will be auto-paused in 2 minutes if there is no response.",
  //   icon: getNotificationIcon(),
  //   tag: NOTIFICATION_TAG_IDLE,
  //   requireInteraction: true,
  //   silent: false,
  // });
  //
  // idleNotification.onclick = (event) => {
  //   event?.preventDefault?.();
  //   window.focus();
  //   onOpenDashboard?.();
  //   closeIdleDesktopAlert();
  // };
  //
  // return true;
  void onOpenDashboard;
  void playAlertTone;
  void startTitleFlash;
  void getNotificationIcon;
  void NOTIFICATION_TAG_IDLE;
  return false;
};

export const showAutoPauseDesktopAlert = () => {
  // stopTitleFlash();
  // closeIdleDesktopAlert();
  //
  // if (!isDesktopNotificationSupported() || Notification.permission !== "granted") {
  //   return false;
  // }
  //
  // const notification = new Notification("Time Tracker — Session Paused", {
  //   body: "Your session was automatically paused due to inactivity. Open the dashboard and tap Resume to continue.",
  //   icon: getNotificationIcon(),
  //   tag: NOTIFICATION_TAG_AUTO_PAUSE,
  //   requireInteraction: true,
  // });
  //
  // notification.onclick = () => {
  //   window.focus();
  //   notification.close();
  // };
  //
  // return true;
  void NOTIFICATION_TAG_AUTO_PAUSE;
  return false;
};

export const clearTimeTrackerDesktopAlerts = () => {
  stopTitleFlash();
  closeIdleDesktopAlert();
};
